var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavViewReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18177 23854)",
    "data-name": "Group 4392"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-18177 -23854)",
    width: 32,
    height: 32,
    fill: "none",
    opacity: 0,
    "data-name": "Rectangle 5680"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18838 -24068)",
    "data-name": "Group 4389"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Path 1311"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.953,228.891A13,13,0,0,0,677,217c-.168,0-.337,0-.506.01a13,13,0,0,0-.6,25.943c.03,0,.06,0,.089,0a1.01,1.01,0,0,0,1.02-1V230h11.955A1.012,1.012,0,0,0,689.953,228.891Zm-1,.109h-10.9l4.736-9.473A12.043,12.043,0,0,1,688.955,229Zm-7.052-9.924-4.9,9.806V218A11.837,11.837,0,0,1,681.9,219.076Zm-5.928,22.881a11.983,11.983,0,0,1-10.966-12.426A12.194,12.194,0,0,1,676,218.056V230Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677 217c6.806 0 12.391 5.23 12.953 11.891 0.049988 0.59299-0.40399 1.109-0.99799 1.109h-11.955v11.955c0 0.564-0.46503 1.002-1.02 1.002-0.028992 0-0.05896-0.0010071-0.088989-0.0039978-6.825-0.576-12.149-6.426-11.881-13.459 0.25397-6.693 5.791-12.23 12.484-12.484 0.16901-0.0069885 0.33795-0.0099945 0.50598-0.0099945zm0 11.882l4.903-9.806c-1.507-0.68401-3.165-1.076-4.903-1.076v10.882zm-1.025 13.075l0.025024-11.957v-11.944c-5.885 0.50301-10.765 5.533-10.991 11.475-0.24396 6.428 4.573 11.886 10.966 12.426zm12.98-12.957c-0.34302-4.092-2.769-7.578-6.16-9.473l-4.736 9.473h10.896z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M679,232v10.952a.027.027,0,0,0,.018.005h0a12,12,0,0,0,10.939-10.938.024.024,0,0,0-.005-.019H679m-1-1h11.954a1.011,1.011,0,0,1,1,1.1A13,13,0,0,1,679.1,243.954a1.01,1.01,0,0,1-1.1-1Z",
    "data-name": "Path 1312"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavViewReports);
export default __webpack_public_path__ + "static/media/nav-view-reports.795d47de69ef4e1b32310800a7b9471c.svg";
export { ForwardRef as ReactComponent };